/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import parse from 'html-react-parser';
import './index.css';
import { Container } from 'react-bootstrap';

function AboutLoanProgram({ data }) {
  const { programItems } = data;
  
  return (
    <Container>
      {programItems.map((item, index) => (
        <div key={index} className="about-loan-program-section">
          <h2 
            className="section-title" 
            style={{
              color: item.titleColor || '#060C44',
              textDecorationColor: item.underlineColor || '#3f3d56'
            }}
          >
            {item.title}
          </h2>
          <div className="section-description">
            {parse(item.description)}
          </div>
        </div>
      ))}
    </Container>
  );
}

export default AboutLoanProgram;